import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tutorial-edit-modal',
  templateUrl: './tutorial-edit-modal.component.html',
  styleUrls: ['./tutorial-edit-modal.component.css']
})
export class TutorialEditModalComponent implements OnInit {

  @Input() tutorial: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

    ngOnInit() {
  }

  onSaveTutorial(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }

}
